import { isContentFragment, isContentFragmentArray, } from '../content-types';
export const universalEditorConnectionName = 'aemconnection';
export function createUniversalEditorResource(resource) {
    return `urn:${universalEditorConnectionName}:${resource}/jcr:content/data/master`;
}
export function createUniversalEditorFilterId(modelPath, fieldName) {
    if (!modelPath || !fieldName) {
        return '';
    }
    return `${modelPath}|${fieldName}`;
}
const validationData = {
    text: {
        required: ['data-aue-prop'],
        notAvailable: ['data-aue-filter', 'data-aue-model'],
    },
    richtext: {
        required: ['data-aue-prop'],
        notAvailable: ['data-aue-filter', 'data-aue-model'],
    },
    media: {
        required: ['data-aue-prop'],
        notAvailable: ['data-aue-model'],
    },
    container: {
        required: ['data-aue-prop'],
        notAvailable: ['data-aue-behavior', 'data-aue-model'],
    },
    component: {
        required: ['data-aue-resource'],
        notAvailable: ['data-aue-prop', 'data-aue-filter', 'data-aue-behavior'],
    },
    reference: {
        required: ['data-aue-resource'],
        notAvailable: [],
    },
};
export const validateUeData = (data) => {
    const singleValidationData = validationData[data['data-aue-type']];
    if (!singleValidationData) {
        console.warn(`The type "${data['data-aue-type']}" is not a valid/supported type`, data);
    }
    const missingFields = singleValidationData.required.reduce((listOfFields, singleField) => {
        if (!data[singleField]) {
            listOfFields.push(singleField);
        }
        return listOfFields;
    }, []);
    if (missingFields.length > 0) {
        console.warn(`The type "${data['data-aue-type']}" requires the following fields "${missingFields.join(', ')}"`, data);
    }
    const notAvailableFields = singleValidationData.notAvailable.reduce((listOfFields, singleField) => {
        if (data[singleField]) {
            listOfFields.push(singleField);
        }
        return listOfFields;
    }, []);
    if (notAvailableFields.length > 0) {
        console.warn(`The type "${data['data-aue-type']}" should not use the field "${notAvailableFields.join(', ')}"`, data);
    }
};
export const findModelAndFragmentForPath = (fragment, propertyPath) => {
    const pathFragments = propertyPath.split('.');
    let lastPropertyName = pathFragments[0];
    let parentModel;
    let parentModelUsingField = {
        lastPropertyName,
        parentModel,
    };
    if (isContentFragment(fragment)) {
        const result = pathFragments.reduce((singleFragment, propertyPathSegment, currentIndex) => {
            const pathSegmentAsNumber = parseInt(propertyPathSegment, 10);
            const isPropertyName = Number.isNaN(pathSegmentAsNumber);
            if (isPropertyName) {
                lastPropertyName = propertyPathSegment;
            }
            if (isContentFragment(singleFragment)) {
                const singleField = singleFragment.fields[propertyPathSegment];
                if (currentIndex === pathFragments.length - 1 && isPropertyName) {
                    parentModel = singleFragment.model;
                }
                if (isContentFragment(singleField) ||
                    isContentFragmentArray(singleField)) {
                    return singleField;
                }
                return undefined;
            }
            if (isContentFragmentArray(singleFragment)) {
                if (isPropertyName) {
                    console.warn(`For the path segment ${propertyPathSegment} we found a array of ContentFragments and expect it to be a number`);
                    return undefined;
                }
                return singleFragment[pathSegmentAsNumber];
            }
            return undefined;
        }, fragment);
        parentModelUsingField = {
            parentModel,
            lastPropertyName,
            fragment: result,
        };
    }
    return parentModelUsingField;
};
export function getFullContainerSegments(path) {
    const segments = path.split('.');
    return segments.flatMap((segment, index) => index === 0 || !Number.isNaN(Number(segment))
        ? [segment]
        : ['fields', segment]);
}
export const getUeContextUpdate = (ueContext, propertyPath, missingContent) => {
    const clonedUeContext = structuredClone(ueContext);
    if (!clonedUeContext.isFalconContent ||
        !clonedUeContext.isAuthorMode ||
        !clonedUeContext.rawCmsContent) {
        return clonedUeContext;
    }
    let propertyPathPosition = clonedUeContext.rawCmsContent.fields;
    const pathSegments = getFullContainerSegments(propertyPath);
    pathSegments.forEach((segment, i) => {
        if (!Number.isNaN(Number(segment))) {
            const index = Number(segment);
            if (!Array.isArray(propertyPathPosition)) {
                throw new Error(`Expected array at ${pathSegments[i - 1]}[${segment}]`);
            }
            if (index < 0 || index >= propertyPathPosition.length) {
                throw new Error(`Array index ${index} is out of bounds at ${pathSegments
                    .slice(0, i + 1)
                    .join('.')}<---, as ${pathSegments[i - 1]}[] has an actual size of ${propertyPathPosition.length}.`);
            }
            propertyPathPosition = propertyPathPosition[index];
        }
        else {
            if (!propertyPathPosition[segment]) {
                propertyPathPosition[segment] = {};
            }
            propertyPathPosition = propertyPathPosition[segment];
        }
    });
    propertyPathPosition.fields = {
        ...(propertyPathPosition.fields || {}),
        ...missingContent,
    };
    return clonedUeContext;
};
//# sourceMappingURL=utils.js.map